import React from "react";

import brandLogo from "../../../logos/zoniq.png";
import { eventOsTabs, pnlTabs, tabLabels, TabId, WorkspaceArea } from "../types";

type Props = {
  area: WorkspaceArea;
  tab: TabId;
  onSelectTab: (tabId: TabId) => void;
};

export const EventOSSidebar: React.FC<Props> = ({ area, tab, onSelectTab }) => (
  <aside className="eventos-sidebar" aria-label="Navigation">
    <div className="eventos-sidebar-header">
      <div className="eventos-brand eventos-brand--drawer">
        <div className="eventos-brand-mark">
          <img src={brandLogo} alt="" className="eventos-brand-mark-img" />
        </div>
        <div className="eventos-brand-copy">
          <div className="eventos-brand-eyebrow">ZONIQ PLATFORM</div>
          <div className="eventos-brand-title">{area === "event-os" ? "EventOS" : "P&L"}</div>
          <div className="eventos-brand-sub">
            {area === "event-os" ? "Operations & Live Intelligence" : "Finance & Profitability Intelligence"}
          </div>
        </div>
      </div>
    </div>
    <div className="eventos-sidebar-scroll">
      <nav className="eventos-nav" aria-label={area === "event-os" ? "EventOS sections" : "P&L sections"}>
        <div className="eventos-nav-group-title">{area === "event-os" ? "EventOS Features" : "P&L Functions"}</div>
        {(area === "event-os" ? eventOsTabs : pnlTabs).map((tabId) => (
          <button
            key={`${area}-${tabId}`}
            className={`eventos-nav-btn ${tabId === tab ? "active" : ""}`}
            type="button"
            onClick={() => onSelectTab(tabId)}
          >
            {tabLabels[tabId]}
          </button>
        ))}
      </nav>
    </div>
  </aside>
);
